function createInactiveScoringTarget() {
  return {
    id: null,
    type: null,
  }
}

function activateQuestionTarget(id) {
  return {
    id,
    type: 'question',
  }
}

function activateSectionTarget(id) {
  return {
    id,
    type: 'section',
  }
}

function isQuestionTargetActive(activeTarget, id) {
  return activeTarget?.type === 'question' && activeTarget?.id === id
}

function isSectionTargetActive(activeTarget, id) {
  return activeTarget?.type === 'section' && activeTarget?.id === id
}

export {
  activateQuestionTarget,
  activateSectionTarget,
  createInactiveScoringTarget,
  isQuestionTargetActive,
  isSectionTargetActive
}
